import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import { buildPath } from "@/lib/routes";
import { useLang } from "@/hooks/useLang";
import { LineReveal, Reveal } from "@/components/motion/Reveal";

export default function PageHero({ eyebrow, title, description, crumbs = [] }) {
  const { lang } = useLang();
  return (
    <section className="relative border-b border-border px-6 md:px-12 lg:px-20 pt-14 pb-16 md:pt-20 md:pb-20">
      {crumbs.length > 0 && (
        <nav className="mb-8 flex flex-wrap items-center gap-2 text-xs text-muted-foreground" aria-label="Breadcrumb">
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              {c.to ? (
                <Link to={buildPath(c.to, lang, c.params || {})} className="transition-colors hover:text-primary">
                  {c.label}
                </Link>
              ) : (
                <span className="text-foreground">{c.label}</span>
              )}
              {i < crumbs.length - 1 && <CaretRight size={11} />}
            </span>
          ))}
        </nav>
      )}
      {eyebrow && <div className="label-mono mb-5 text-primary">{eyebrow}</div>}
      <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95] max-w-4xl">
        <LineReveal lines={Array.isArray(title) ? title : [title]} />
      </h1>
      {description && (
        <Reveal delay={0.4}>
          <p className="mt-7 max-w-2xl text-lg text-muted-foreground font-light leading-relaxed">
            {description}
          </p>
        </Reveal>
      )}
    </section>
  );
}
